import { postData, formData } from "@utils";

export async function reconciliationList({ options, search, signal } = {}) {
  const payload = {
    method: "ESMMutabakat",
    func: "getMutabakatList",
  };
  if (options) payload.options = JSON.stringify(options);
  if (search) Object.assign(payload, search);

  return postData(payload, signal);
}

export async function reconciliationPdf({ mutabakat_no, customer, signal } = {}) {
  const payload = {
    method: "ESMMutabakat",
    func: "getMutabakatPDF",
    mutabakat_no,
  };
  if (customer) payload.customer = customer;

  return postData(payload, signal);
}

export async function getCustomerPendingMutabakat({ signal } = {}) {
  const payload = {
    method: "ESMMutabakat",
    func: "getCustomerPendingMutabakat",
  };

  return postData(payload, signal);
}

export async function getCustomerMutabakatApprovals({ search, signal } = {}) {
  const payload = {
    method: "ESMMutabakat",
    func: "getCustomerMutabakatApprovals",
  };
  if (search) Object.assign(payload, search);

  return postData(payload, signal);
}

export async function setMutabakatApproval({ mutabakat_no, action, note, file, signal } = {}) {
  const fd = new FormData();
  fd.append("method", "ESMMutabakat");
  fd.append("func", "setMutabakatApproval");
  fd.append("mutabakat_no", mutabakat_no);
  fd.append("action", action);
  if (note) fd.append("note", note);
  if (file) fd.append("file", file);

  return formData(fd, signal);
}
